import React from 'react';

type Props = {
  icon: React.ReactNode;
  title: string;
  value: string | number;
};

export default function StatCard({ icon, title, value }: Props) {
  return (
    <article className="flex items-center gap-5 rounded-2xl border border-gray-200 bg-white p-4 dark:border-darkBorderCard dark:bg-white/[0.03] ">
      <div className="inline-flex h-16 w-16 items-center justify-center rounded-xl bg-gray-100 text-gray-800 dark:bg-darkDarkGray dark:text-white/90">
        {icon}
      </div>
      <div>
        <h3 className="text-2xl font-semibold text-gray-800 dark:text-white/90">
          {value}
        </h3>
        <p className="text-gray-500 dark:text-gray-400">{title}</p>
      </div>
    </article>
  );
}
